import axios from "axios";
import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

export const fetchHotels = async (
  destinationId?: number, 
  nights?: number,
  checkin?: string,
  adults?: number,
  children?: number,
  agesChildren?: number[]
) => {
  const authToken = getCookie("auth_token");
  const base = axios.create({
    baseURL: BASE_URL_API,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${authToken}`,
    },
  });

  if (authToken) {
    const response = await base.get("/hotels", {
      params: {
        des: destinationId,
        nights,
        checkin,
        adults,
        children,
        ages_children: String(agesChildren)
      },
    });

    return response.data;
  }
};
